// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddDocumentToClientPackageData, AddDocumentToClientPackageResponses, CheckClientPackageDocumentsData, CheckClientPackageDocumentsErrors, CheckClientPackageDocumentsResponses, ClearAllTokensData, ClearAllTokensErrors, ClearAllTokensResponses, ClearExpiredTokensData, ClearExpiredTokensErrors, ClearExpiredTokensResponses, CreateAdvisoryNeedData, CreateAdvisoryNeedErrors, CreateAdvisoryNeedResponses, CreateAdvisoryNeedTaskData, CreateAdvisoryNeedTaskErrors, CreateAdvisoryNeedTaskResponses, CreateAppendixDocumentData, CreateAppendixDocumentErrors, CreateAppendixDocumentResponses, CreateClientPackageData, CreateClientPackageErrors, CreateClientPackageResponses, CreateClientTalkingPointRelationData, CreateClientTalkingPointRelationErrors, CreateClientTalkingPointRelationResponses, CreateDocumentData, CreateDocumentErrors, CreateDocumentResponses, CreateGenericDocumentsData, CreateGenericDocumentsErrors, CreateGenericDocumentsResponses, CreateLifeEventData, CreateLifeEventErrors, CreateLifeEventResponses, CreateSurplusItemData, CreateSurplusItemErrors, CreateSurplusItemResponses, CreateTalkingPointData, CreateTalkingPointErrors, CreateTalkingPointResponses, CreateToolData, CreateToolErrors, CreateToolResponses, CreateTopicData, CreateTopicErrors, CreateTopicResponses, DeleteAdvisoryNeedData, DeleteAdvisoryNeedErrors, DeleteAdvisoryNeedResponses, DeleteAdvisoryNeedTaskData, DeleteAdvisoryNeedTaskErrors, DeleteAdvisoryNeedTaskResponses, DeleteAllNodePositionsData, DeleteAllNodePositionsErrors, DeleteAllNodePositionsResponses, DeleteAppendixDocumentData, DeleteAppendixDocumentErrors, DeleteAppendixDocumentResponses, DeleteClientTalkingPointRelationData, DeleteClientTalkingPointRelationErrors, DeleteClientTalkingPointRelationResponses, DeleteDocumentData, DeleteDocumentErrors, DeleteDocumentResponses, DeleteLifeEventData, DeleteLifeEventErrors, DeleteLifeEventResponses, DeleteSurplusItemData, DeleteSurplusItemErrors, DeleteSurplusItemResponses, DeleteTalkingPointData, DeleteTalkingPointErrors, DeleteTalkingPointResponses, DeleteTopicData, DeleteTopicErrors, DeleteTopicResponses, DeLinkTalkingPointData, DeLinkTalkingPointErrors, DeLinkTalkingPointResponses, DownloadDocumentData, DownloadDocumentErrors, DownloadDocumentResponses, FinalizeClientPackageData, FinalizeClientPackageErrors, FinalizeClientPackageResponses, GenerateCashFlowForClientData, GenerateCashFlowForClientErrors, GenerateCashFlowForClientResponses, GenerateSaEngineProjectionForClientData, GenerateSaEngineProjectionForClientErrors, GenerateSaEngineProjectionForClientResponses, GetAdvisoryNeedsContentForTalkingPointData, GetAdvisoryNeedsContentForTalkingPointErrors, GetAdvisoryNeedsContentForTalkingPointResponses, GetAdvisoryNeedsData, GetAdvisoryNeedsErrors, GetAdvisoryNeedsForTalkingPointData, GetAdvisoryNeedsForTalkingPointErrors, GetAdvisoryNeedsForTalkingPointResponses, GetAdvisoryNeedsResponses, GetAdvisoryNeedTasksForClientData, GetAdvisoryNeedTasksForClientErrors, GetAdvisoryNeedTasksForClientResponses, GetAdvisoryNeedTasksForLoggedInUserData, GetAdvisoryNeedTasksForLoggedInUserErrors, GetAdvisoryNeedTasksForLoggedInUserResponses, GetAllDomicilesData, GetAllDomicilesErrors, GetAllDomicilesResponses, GetAllNotificationsData, GetAllNotificationsErrors, GetAllNotificationsResponses, GetAppendixDocumentData, GetAppendixDocumentErrors, GetAppendixDocumentResponses, GetBalanceSheetData, GetBalanceSheetErrors, GetBalanceSheetResponses, GetBusinessRelationshipWithMostAssetsUnderManagementByRequestData, GetBusinessRelationshipWithMostAssetsUnderManagementByRequestErrors, GetBusinessRelationshipWithMostAssetsUnderManagementByRequestResponses, GetBusinessRelationshipWithMostAssetsUnderManagementData, GetBusinessRelationshipWithMostAssetsUnderManagementErrors, GetBusinessRelationshipWithMostAssetsUnderManagementResponses, GetCalculatorUrlsData, GetCalculatorUrlsErrors, GetCalculatorUrlsResponses, GetCashEventSettingsData, GetCashEventSettingsErrors, GetCashEventSettingsResponses, GetCashFlowSettingsData, GetCashFlowSettingsErrors, GetCashFlowSettingsResponses, GetClientDetailsByPartnerUuidData, GetClientDetailsByPartnerUuidErrors, GetClientDetailsByPartnerUuidResponses, GetClientDetailsData, GetClientDetailsErrors, GetClientDetailsResponses, GetClientPackageData, GetClientPackageErrors, GetClientPackageResponses, GetClientPackagesForClientData, GetClientPackagesForClientErrors, GetClientPackagesForClientResponses, GetClientsForLoggedInUserData, GetClientsForLoggedInUserResponses, GetDbExportData, GetDbExportErrors, GetDbExportResponses, GetDocumentsData, GetDocumentsErrors, GetDocumentsForTalkingPointData, GetDocumentsForTalkingPointErrors, GetDocumentsForTalkingPointResponses, GetDocumentsResponses, GetEnabledDomicilesData, GetEnabledDomicilesErrors, GetEnabledDomicilesResponses, GetEventsData, GetEventsErrors, GetEventsResponses, GetExternalAssetsSettingsData, GetExternalAssetsSettingsErrors, GetExternalAssetsSettingsResponses, GetFamilyTreeData, GetFamilyTreeErrors, GetFamilyTreeResponses, GetFinalizedClientPackageDocumentsZipArchiveData, GetFinalizedClientPackageDocumentsZipArchiveErrors, GetFinalizedClientPackageDocumentsZipArchiveResponses, GetFrontendConfigurationData, GetFrontendConfigurationErrors, GetFrontendConfigurationResponses, GetGeneralSettingsData, GetGeneralSettingsErrors, GetGeneralSettingsResponses, GetInternalAssetsSettingsData, GetInternalAssetsSettingsErrors, GetInternalAssetsSettingsResponses, GetLifeEventsData, GetLifeEventsErrors, GetLifeEventsForClientData, GetLifeEventsForClientErrors, GetLifeEventsForClientResponses, GetLifeEventsResponses, GetLiquidityCalculatorCalculationData, GetLiquidityCalculatorCalculationErrors, GetLiquidityCalculatorCalculationResponses, GetLiquidityCashWithJbSettingsData, GetLiquidityCashWithJbSettingsErrors, GetLiquidityCashWithJbSettingsResponses, GetLiquidityCashWithOtherBanksSettingsData, GetLiquidityCashWithOtherBanksSettingsErrors, GetLiquidityCashWithOtherBanksSettingsResponses, GetLiquidityOneOffCashflowSettingsData, GetLiquidityOneOffCashflowSettingsErrors, GetLiquidityOneOffCashflowSettingsResponses, GetLiquidityOverviewActivatedData, GetLiquidityOverviewActivatedErrors, GetLiquidityOverviewActivatedResponses, GetLiquidityOverviewData, GetLiquidityOverviewErrors, GetLiquidityOverviewResponses, GetLiquidityRecurringCashflowSettingsData, GetLiquidityRecurringCashflowSettingsErrors, GetLiquidityRecurringCashflowSettingsResponses, GetNotificationsData, GetNotificationsErrors, GetNotificationsResponses, GetPartnersByBusinessRelationshipUuidData, GetPartnersByBusinessRelationshipUuidErrors, GetPartnersByBusinessRelationshipUuidResponses, GetReferenceTreeForTalkingPointData, GetReferenceTreeForTalkingPointErrors, GetReferenceTreeForTalkingPointResponses, GetSurplusEntriesData, GetSurplusEntriesErrors, GetSurplusEntriesResponses, GetTalkingPointsData, GetTalkingPointsErrors, GetTalkingPointsForDomicileByTopicIdData, GetTalkingPointsForDomicileByTopicIdErrors, GetTalkingPointsForDomicileByTopicIdResponses, GetTalkingPointsResponses, GetToolsData, GetToolsErrors, GetToolsResponses, GetTopicData, GetTopicErrors, GetTopicResponses, GetTopLevelTopicsData, GetTopLevelTopicsErrors, GetTopLevelTopicsResponses, GetUserDetailsData, GetUserDetailsErrors, GetUserDetailsResponses, LinkTalkingPointData, LinkTalkingPointErrors, LinkTalkingPointResponses, ReloadMaturitiesData, ReloadMaturitiesErrors, ReloadMaturitiesResponses, RemoveDocumentFromClientPackageData, RemoveDocumentFromClientPackageErrors, RemoveDocumentFromClientPackageResponses, RenderClientPackageData, RenderClientPackageErrors, RenderClientPackageResponses, ReOrderTopicsAndTalkingPointsData, ReOrderTopicsAndTalkingPointsErrors, ReOrderTopicsAndTalkingPointsResponses, RetrieveVersionData, RetrieveVersionErrors, RetrieveVersionResponses, SearchPartnersByTermData, SearchPartnersByTermErrors, SearchPartnersByTermResponses, SelectAllLiquidityOneOffCashflowItemsData, SelectAllLiquidityOneOffCashflowItemsErrors, SelectAllLiquidityOneOffCashflowItemsResponses, SelectAllLiquidityRecurringCashflowItemsData, SelectAllLiquidityRecurringCashflowItemsErrors, SelectAllLiquidityRecurringCashflowItemsResponses, StoreClientData, StoreClientErrors, StoreClientResponses, StoreCurrencyData, StoreCurrencyErrors, StoreCurrencyResponses, UpdateAdvisoryNeedData, UpdateAdvisoryNeedErrors, UpdateAdvisoryNeedResponses, UpdateAdvisoryNeedTaskData, UpdateAdvisoryNeedTaskErrors, UpdateAdvisoryNeedTaskResponses, UpdateAppendixDocumentData, UpdateAppendixDocumentErrors, UpdateAppendixDocumentResponses, UpdateCashEventItemSettingsData, UpdateCashEventItemSettingsErrors, UpdateCashEventItemSettingsResponses, UpdateCashEventPanelSettingsData, UpdateCashEventPanelSettingsErrors, UpdateCashEventPanelSettingsResponses, UpdateCashFlowItemSettingsData, UpdateCashFlowItemSettingsErrors, UpdateCashFlowItemSettingsResponses, UpdateCashFlowPanelSettingsData, UpdateCashFlowPanelSettingsErrors, UpdateCashFlowPanelSettingsResponses, UpdateClientPackageData, UpdateClientPackageErrors, UpdateClientPackageResponses, UpdateDocumentData, UpdateDocumentErrors, UpdateDocumentResponses, UpdateDomicileData, UpdateDomicileErrors, UpdateDomicileResponses, UpdateExternalItemSettingsData, UpdateExternalItemSettingsErrors, UpdateExternalItemSettingsResponses, UpdateExternalSettingsData, UpdateExternalSettingsErrors, UpdateExternalSettingsResponses, UpdateGeneralSettingsData, UpdateGeneralSettingsErrors, UpdateGeneralSettingsResponses, UpdateInternalItemSettingsData, UpdateInternalItemSettingsErrors, UpdateInternalItemSettingsResponses, UpdateInternalSettingsData, UpdateInternalSettingsErrors, UpdateInternalSettingsResponses, UpdateLifeEventData, UpdateLifeEventErrors, UpdateLifeEventResponses, UpdateLiquidityCalculatorCalculationData, UpdateLiquidityCalculatorCalculationErrors, UpdateLiquidityCalculatorCalculationResponses, UpdateLiquidityCashWithJbItemSettingsData, UpdateLiquidityCashWithJbItemSettingsErrors, UpdateLiquidityCashWithJbItemSettingsResponses, UpdateLiquidityCashWithJbPanelSettingsData, UpdateLiquidityCashWithJbPanelSettingsErrors, UpdateLiquidityCashWithJbPanelSettingsResponses, UpdateLiquidityCashWithOtherBanksItemSettingsData, UpdateLiquidityCashWithOtherBanksItemSettingsErrors, UpdateLiquidityCashWithOtherBanksItemSettingsResponses, UpdateLiquidityCashWithOtherBanksPanelSettingsData, UpdateLiquidityCashWithOtherBanksPanelSettingsErrors, UpdateLiquidityCashWithOtherBanksPanelSettingsResponses, UpdateLiquidityOneOffCashflowItemSettingsData, UpdateLiquidityOneOffCashflowItemSettingsErrors, UpdateLiquidityOneOffCashflowItemSettingsResponses, UpdateLiquidityOneOffCashflowPanelSettingsData, UpdateLiquidityOneOffCashflowPanelSettingsErrors, UpdateLiquidityOneOffCashflowPanelSettingsResponses, UpdateLiquidityRecurringCashflowItemSettingsData, UpdateLiquidityRecurringCashflowItemSettingsErrors, UpdateLiquidityRecurringCashflowItemSettingsResponses, UpdateLiquidityRecurringCashflowPanelSettingsData, UpdateLiquidityRecurringCashflowPanelSettingsErrors, UpdateLiquidityRecurringCashflowPanelSettingsResponses, UpdateMaturityEventData, UpdateMaturityEventErrors, UpdateMaturityEventResponses, UpdateNodePositionData, UpdateNodePositionErrors, UpdateNodePositionResponses, UpdateNodeVisibilityData, UpdateNodeVisibilityErrors, UpdateNodeVisibilityResponses, UpdateSurplusItemData, UpdateSurplusItemErrors, UpdateSurplusItemResponses, UpdateSurplusPanelData, UpdateSurplusPanelErrors, UpdateSurplusPanelResponses, UpdateTalkingPointData, UpdateTalkingPointErrors, UpdateTalkingPointResponses, UpdateToolData, UpdateToolErrors, UpdateToolResponses, UpdateTopicData, UpdateTopicErrors, UpdateTopicResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Delete a topic
 */
export const deleteTopic = <ThrowOnError extends boolean = false>(options: Options<DeleteTopicData, ThrowOnError>): RequestResult<DeleteTopicResponses, DeleteTopicErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTopicResponses, DeleteTopicErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/{id}',
    ...options
});

/**
 * Given a topic id, it returns the topic
 */
export const getTopic = <ThrowOnError extends boolean = false>(options: Options<GetTopicData, ThrowOnError>): RequestResult<GetTopicResponses, GetTopicErrors, ThrowOnError> => (options.client ?? client).get<GetTopicResponses, GetTopicErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/{id}',
    ...options
});

/**
 * Update an existing topic
 */
export const updateTopic = <ThrowOnError extends boolean = false>(options: Options<UpdateTopicData, ThrowOnError>): RequestResult<UpdateTopicResponses, UpdateTopicErrors, ThrowOnError> => (options.client ?? client).put<UpdateTopicResponses, UpdateTopicErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Given a topic id, it returns the topic
 */
export const linkTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<LinkTalkingPointData, ThrowOnError>): RequestResult<LinkTalkingPointResponses, LinkTalkingPointErrors, ThrowOnError> => (options.client ?? client).put<LinkTalkingPointResponses, LinkTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/{id}/link-talking-point/{talking-point-id}',
    ...options
});

/**
 * Given a topic id, it returns the topic
 */
export const deLinkTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<DeLinkTalkingPointData, ThrowOnError>): RequestResult<DeLinkTalkingPointResponses, DeLinkTalkingPointErrors, ThrowOnError> => (options.client ?? client).put<DeLinkTalkingPointResponses, DeLinkTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/{id}/de-link-talking-point/{talking-point-id}',
    ...options
});

/**
 * Create a new topic
 */
export const createTopic = <ThrowOnError extends boolean = false>(options: Options<CreateTopicData, ThrowOnError>): RequestResult<CreateTopicResponses, CreateTopicErrors, ThrowOnError> => (options.client ?? client).post<CreateTopicResponses, CreateTopicErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re order topics and talking points
 */
export const reOrderTopicsAndTalkingPoints = <ThrowOnError extends boolean = false>(options: Options<ReOrderTopicsAndTalkingPointsData, ThrowOnError>): RequestResult<ReOrderTopicsAndTalkingPointsResponses, ReOrderTopicsAndTalkingPointsErrors, ThrowOnError> => (options.client ?? client).put<ReOrderTopicsAndTalkingPointsResponses, ReOrderTopicsAndTalkingPointsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/re-order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a tool.
 */
export const updateTool = <ThrowOnError extends boolean = false>(options: Options<UpdateToolData, ThrowOnError>): RequestResult<UpdateToolResponses, UpdateToolErrors, ThrowOnError> => (options.client ?? client).put<UpdateToolResponses, UpdateToolErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tools/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a talking point
 */
export const deleteTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<DeleteTalkingPointData, ThrowOnError>): RequestResult<DeleteTalkingPointResponses, DeleteTalkingPointErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTalkingPointResponses, DeleteTalkingPointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/talking-points/{id}',
    ...options
});

/**
 * Update an existing talking point
 */
export const updateTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<UpdateTalkingPointData, ThrowOnError>): RequestResult<UpdateTalkingPointResponses, UpdateTalkingPointErrors, ThrowOnError> => (options.client ?? client).put<UpdateTalkingPointResponses, UpdateTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/talking-points/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a surplus item
 */
export const updateSurplusPanel = <ThrowOnError extends boolean = false>(options: Options<UpdateSurplusPanelData, ThrowOnError>): RequestResult<UpdateSurplusPanelResponses, UpdateSurplusPanelErrors, ThrowOnError> => (options.client ?? client).put<UpdateSurplusPanelResponses, UpdateSurplusPanelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/surplus-settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a surplus item
 */
export const deleteSurplusItem = <ThrowOnError extends boolean = false>(options: Options<DeleteSurplusItemData, ThrowOnError>): RequestResult<DeleteSurplusItemResponses, DeleteSurplusItemErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSurplusItemResponses, DeleteSurplusItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/surplus-settings/item/{id}',
    ...options
});

/**
 * Updates a surplus item
 */
export const updateSurplusItem = <ThrowOnError extends boolean = false>(options: Options<UpdateSurplusItemData, ThrowOnError>): RequestResult<UpdateSurplusItemResponses, UpdateSurplusItemErrors, ThrowOnError> => (options.client ?? client).put<UpdateSurplusItemResponses, UpdateSurplusItemErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/surplus-settings/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateInternalSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateInternalSettingsData, ThrowOnError>): RequestResult<UpdateInternalSettingsResponses, UpdateInternalSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateInternalSettingsResponses, UpdateInternalSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/internal-assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateInternalItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateInternalItemSettingsData, ThrowOnError>): RequestResult<UpdateInternalItemSettingsResponses, UpdateInternalItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateInternalItemSettingsResponses, UpdateInternalItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/internal-assets/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a sae client simulation settings
 */
export const updateGeneralSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateGeneralSettingsData, ThrowOnError>): RequestResult<UpdateGeneralSettingsResponses, UpdateGeneralSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateGeneralSettingsResponses, UpdateGeneralSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/general/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateExternalSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateExternalSettingsData, ThrowOnError>): RequestResult<UpdateExternalSettingsResponses, UpdateExternalSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateExternalSettingsResponses, UpdateExternalSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/external-assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateExternalItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateExternalItemSettingsData, ThrowOnError>): RequestResult<UpdateExternalItemSettingsResponses, UpdateExternalItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateExternalItemSettingsResponses, UpdateExternalItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/external-assets/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateCashFlowPanelSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateCashFlowPanelSettingsData, ThrowOnError>): RequestResult<UpdateCashFlowPanelSettingsResponses, UpdateCashFlowPanelSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateCashFlowPanelSettingsResponses, UpdateCashFlowPanelSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/cash-flow/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateCashFlowItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateCashFlowItemSettingsData, ThrowOnError>): RequestResult<UpdateCashFlowItemSettingsResponses, UpdateCashFlowItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateCashFlowItemSettingsResponses, UpdateCashFlowItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/cash-flow/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateCashEventPanelSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateCashEventPanelSettingsData, ThrowOnError>): RequestResult<UpdateCashEventPanelSettingsResponses, UpdateCashEventPanelSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateCashEventPanelSettingsResponses, UpdateCashEventPanelSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/cash-event/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateCashEventItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateCashEventItemSettingsData, ThrowOnError>): RequestResult<UpdateCashEventItemSettingsResponses, UpdateCashEventItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateCashEventItemSettingsResponses, UpdateCashEventItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/cash-event/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update maturity event
 */
export const updateMaturityEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateMaturityEventData, ThrowOnError>): RequestResult<UpdateMaturityEventResponses, UpdateMaturityEventErrors, ThrowOnError> => (options.client ?? client).put<UpdateMaturityEventResponses, UpdateMaturityEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/maturity-events/{clientId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reload wealth overview and update maturity event
 */
export const reloadMaturities = <ThrowOnError extends boolean = false>(options: Options<ReloadMaturitiesData, ThrowOnError>): RequestResult<ReloadMaturitiesResponses, ReloadMaturitiesErrors, ThrowOnError> => (options.client ?? client).put<ReloadMaturitiesResponses, ReloadMaturitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/maturity-events/{clientId}/reload',
    ...options
});

export const updateDomicile = <ThrowOnError extends boolean = false>(options: Options<UpdateDomicileData, ThrowOnError>): RequestResult<UpdateDomicileResponses, UpdateDomicileErrors, ThrowOnError> => (options.client ?? client).put<UpdateDomicileResponses, UpdateDomicileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/domiciles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a document entry of type manually loaded.
 */
export const updateDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentData, ThrowOnError>): RequestResult<UpdateDocumentResponses, UpdateDocumentErrors, ThrowOnError> => (options.client ?? client).put<UpdateDocumentResponses, UpdateDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/manual-upload/{id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Returns clients where the creator is the logged in user
 */
export const getClientsForLoggedInUser = <ThrowOnError extends boolean = false>(options?: Options<GetClientsForLoggedInUserData, ThrowOnError>): RequestResult<GetClientsForLoggedInUserResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetClientsForLoggedInUserResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients',
    ...options
});

/**
 * Stores the client on the database
 */
export const storeClient = <ThrowOnError extends boolean = false>(options: Options<StoreClientData, ThrowOnError>): RequestResult<StoreClientResponses, StoreClientErrors, ThrowOnError> => (options.client ?? client).put<StoreClientResponses, StoreClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stores the client currency on the database
 */
export const storeCurrency = <ThrowOnError extends boolean = false>(options: Options<StoreCurrencyData, ThrowOnError>): RequestResult<StoreCurrencyResponses, StoreCurrencyErrors, ThrowOnError> => (options.client ?? client).put<StoreCurrencyResponses, StoreCurrencyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/{clientId}/{currency}',
    ...options
});

/**
 * Get client packages by ID
 */
export const getClientPackage = <ThrowOnError extends boolean = false>(options: Options<GetClientPackageData, ThrowOnError>): RequestResult<GetClientPackageResponses, GetClientPackageErrors, ThrowOnError> => (options.client ?? client).get<GetClientPackageResponses, GetClientPackageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}',
    ...options
});

/**
 * Updates a client package
 */
export const updateClientPackage = <ThrowOnError extends boolean = false>(options: Options<UpdateClientPackageData, ThrowOnError>): RequestResult<UpdateClientPackageResponses, UpdateClientPackageErrors, ThrowOnError> => (options.client ?? client).put<UpdateClientPackageResponses, UpdateClientPackageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete appendix chapter document from a client package
 */
export const deleteAppendixDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteAppendixDocumentData, ThrowOnError>): RequestResult<DeleteAppendixDocumentResponses, DeleteAppendixDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAppendixDocumentResponses, DeleteAppendixDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/appendix/document/{documentId}',
    ...options
});

/**
 * Get appendix chapter document from a client package
 */
export const getAppendixDocument = <ThrowOnError extends boolean = false>(options: Options<GetAppendixDocumentData, ThrowOnError>): RequestResult<GetAppendixDocumentResponses, GetAppendixDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetAppendixDocumentResponses, GetAppendixDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/appendix/document/{documentId}',
    ...options
});

/**
 * Add appendix chapter document to a client package
 */
export const createAppendixDocument = <ThrowOnError extends boolean = false>(options: Options<CreateAppendixDocumentData, ThrowOnError>): RequestResult<CreateAppendixDocumentResponses, CreateAppendixDocumentErrors, ThrowOnError> => (options.client ?? client).post<CreateAppendixDocumentResponses, CreateAppendixDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/appendix/document/{documentId}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update appendix chapter document of a client package
 */
export const updateAppendixDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateAppendixDocumentData, ThrowOnError>): RequestResult<UpdateAppendixDocumentResponses, UpdateAppendixDocumentErrors, ThrowOnError> => (options.client ?? client).put<UpdateAppendixDocumentResponses, UpdateAppendixDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/appendix/document/{documentId}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete an advisory need
 */
export const deleteAdvisoryNeed = <ThrowOnError extends boolean = false>(options: Options<DeleteAdvisoryNeedData, ThrowOnError>): RequestResult<DeleteAdvisoryNeedResponses, DeleteAdvisoryNeedErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAdvisoryNeedResponses, DeleteAdvisoryNeedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-needs/{id}',
    ...options
});

/**
 * Update an existing advisory need
 */
export const updateAdvisoryNeed = <ThrowOnError extends boolean = false>(options: Options<UpdateAdvisoryNeedData, ThrowOnError>): RequestResult<UpdateAdvisoryNeedResponses, UpdateAdvisoryNeedErrors, ThrowOnError> => (options.client ?? client).put<UpdateAdvisoryNeedResponses, UpdateAdvisoryNeedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-needs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an advisory need task
 */
export const deleteAdvisoryNeedTask = <ThrowOnError extends boolean = false>(options: Options<DeleteAdvisoryNeedTaskData, ThrowOnError>): RequestResult<DeleteAdvisoryNeedTaskResponses, DeleteAdvisoryNeedTaskErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAdvisoryNeedTaskResponses, DeleteAdvisoryNeedTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-need-tasks/{id}',
    ...options
});

/**
 * Update an existing advisory need task
 */
export const updateAdvisoryNeedTask = <ThrowOnError extends boolean = false>(options: Options<UpdateAdvisoryNeedTaskData, ThrowOnError>): RequestResult<UpdateAdvisoryNeedTaskResponses, UpdateAdvisoryNeedTaskErrors, ThrowOnError> => (options.client ?? client).put<UpdateAdvisoryNeedTaskResponses, UpdateAdvisoryNeedTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-need-tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns all tools.
 */
export const getTools = <ThrowOnError extends boolean = false>(options?: Options<GetToolsData, ThrowOnError>): RequestResult<GetToolsResponses, GetToolsErrors, ThrowOnError> => (options?.client ?? client).get<GetToolsResponses, GetToolsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tools',
    ...options
});

/**
 * Creates a tool.
 */
export const createTool = <ThrowOnError extends boolean = false>(options: Options<CreateToolData, ThrowOnError>): RequestResult<CreateToolResponses, CreateToolErrors, ThrowOnError> => (options.client ?? client).post<CreateToolResponses, CreateToolErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tools',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns all talking points
 */
export const getTalkingPoints = <ThrowOnError extends boolean = false>(options?: Options<GetTalkingPointsData, ThrowOnError>): RequestResult<GetTalkingPointsResponses, GetTalkingPointsErrors, ThrowOnError> => (options?.client ?? client).get<GetTalkingPointsResponses, GetTalkingPointsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/talking-points',
    ...options
});

/**
 * Create a new talking point
 */
export const createTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<CreateTalkingPointData, ThrowOnError>): RequestResult<CreateTalkingPointResponses, CreateTalkingPointErrors, ThrowOnError> => (options.client ?? client).post<CreateTalkingPointResponses, CreateTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/talking-points',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a surplus item
 */
export const createSurplusItem = <ThrowOnError extends boolean = false>(options: Options<CreateSurplusItemData, ThrowOnError>): RequestResult<CreateSurplusItemResponses, CreateSurplusItemErrors, ThrowOnError> => (options.client ?? client).post<CreateSurplusItemResponses, CreateSurplusItemErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/surplus-settings/item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the SAEngine Projection of a client
 */
export const generateSaEngineProjectionForClient = <ThrowOnError extends boolean = false>(options: Options<GenerateSaEngineProjectionForClientData, ThrowOnError>): RequestResult<GenerateSaEngineProjectionForClientResponses, GenerateSaEngineProjectionForClientErrors, ThrowOnError> => (options.client ?? client).post<GenerateSaEngineProjectionForClientResponses, GenerateSaEngineProjectionForClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projections/sae-generate/for-client/{clientId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the cashflow (surplus and gross calculations, yearly) of a client
 */
export const generateCashFlowForClient = <ThrowOnError extends boolean = false>(options: Options<GenerateCashFlowForClientData, ThrowOnError>): RequestResult<GenerateCashFlowForClientResponses, GenerateCashFlowForClientErrors, ThrowOnError> => (options.client ?? client).post<GenerateCashFlowForClientResponses, GenerateCashFlowForClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projections/cashflow-generate/for-client/{clientId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a life event
 */
export const createLifeEvent = <ThrowOnError extends boolean = false>(options: Options<CreateLifeEventData, ThrowOnError>): RequestResult<CreateLifeEventResponses, CreateLifeEventErrors, ThrowOnError> => (options.client ?? client).post<CreateLifeEventResponses, CreateLifeEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/life-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a life event
 */
export const deleteLifeEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteLifeEventData, ThrowOnError>): RequestResult<DeleteLifeEventResponses, DeleteLifeEventErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLifeEventResponses, DeleteLifeEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/life-events/{lifeEventId}',
    ...options
});

/**
 * Updates a life event
 */
export const updateLifeEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateLifeEventData, ThrowOnError>): RequestResult<UpdateLifeEventResponses, UpdateLifeEventErrors, ThrowOnError> => (options.client ?? client).post<UpdateLifeEventResponses, UpdateLifeEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/life-events/{lifeEventId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a document entry with manual file loading
 */
export const createDocument = <ThrowOnError extends boolean = false>(options?: Options<CreateDocumentData, ThrowOnError>): RequestResult<CreateDocumentResponses, CreateDocumentErrors, ThrowOnError> => (options?.client ?? client).post<CreateDocumentResponses, CreateDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/manual-upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Creates a new client - talking point relation
 */
export const createClientTalkingPointRelation = <ThrowOnError extends boolean = false>(options: Options<CreateClientTalkingPointRelationData, ThrowOnError>): RequestResult<CreateClientTalkingPointRelationResponses, CreateClientTalkingPointRelationErrors, ThrowOnError> => (options.client ?? client).post<CreateClientTalkingPointRelationResponses, CreateClientTalkingPointRelationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-talking-points',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all client packages for a client
 */
export const getClientPackagesForClient = <ThrowOnError extends boolean = false>(options: Options<GetClientPackagesForClientData, ThrowOnError>): RequestResult<GetClientPackagesForClientResponses, GetClientPackagesForClientErrors, ThrowOnError> => (options.client ?? client).get<GetClientPackagesForClientResponses, GetClientPackagesForClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages',
    ...options
});

/**
 * Creates a new client package
 */
export const createClientPackage = <ThrowOnError extends boolean = false>(options: Options<CreateClientPackageData, ThrowOnError>): RequestResult<CreateClientPackageResponses, CreateClientPackageErrors, ThrowOnError> => (options.client ?? client).post<CreateClientPackageResponses, CreateClientPackageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add appendix chapter document to a client package
 */
export const createGenericDocuments = <ThrowOnError extends boolean = false>(options: Options<CreateGenericDocumentsData, ThrowOnError>): RequestResult<CreateGenericDocumentsResponses, CreateGenericDocumentsErrors, ThrowOnError> => (options.client ?? client).post<CreateGenericDocumentsResponses, CreateGenericDocumentsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}/generic-document',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Finalizes a client package
 */
export const finalizeClientPackage = <ThrowOnError extends boolean = false>(options: Options<FinalizeClientPackageData, ThrowOnError>): RequestResult<FinalizeClientPackageResponses, FinalizeClientPackageErrors, ThrowOnError> => (options.client ?? client).post<FinalizeClientPackageResponses, FinalizeClientPackageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}/finalize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove document from a client package
 */
export const removeDocumentFromClientPackage = <ThrowOnError extends boolean = false>(options: Options<RemoveDocumentFromClientPackageData, ThrowOnError>): RequestResult<RemoveDocumentFromClientPackageResponses, RemoveDocumentFromClientPackageErrors, ThrowOnError> => (options.client ?? client).delete<RemoveDocumentFromClientPackageResponses, RemoveDocumentFromClientPackageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}/documents/{documentId}',
    ...options
});

/**
 * Add document to a client package
 */
export const addDocumentToClientPackage = <ThrowOnError extends boolean = false>(options: Options<AddDocumentToClientPackageData, ThrowOnError>): RequestResult<AddDocumentToClientPackageResponses, unknown, ThrowOnError> => (options.client ?? client).post<AddDocumentToClientPackageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}/documents/{documentId}',
    ...options
});

export const renderClientPackage = <ThrowOnError extends boolean = false>(options: Options<RenderClientPackageData, ThrowOnError>): RequestResult<RenderClientPackageResponses, RenderClientPackageErrors, ThrowOnError> => (options.client ?? client).post<RenderClientPackageResponses, RenderClientPackageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-package-output/render',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns all advisory needs
 */
export const getAdvisoryNeeds = <ThrowOnError extends boolean = false>(options?: Options<GetAdvisoryNeedsData, ThrowOnError>): RequestResult<GetAdvisoryNeedsResponses, GetAdvisoryNeedsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdvisoryNeedsResponses, GetAdvisoryNeedsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-needs',
    ...options
});

/**
 * Create a new advisory need
 */
export const createAdvisoryNeed = <ThrowOnError extends boolean = false>(options: Options<CreateAdvisoryNeedData, ThrowOnError>): RequestResult<CreateAdvisoryNeedResponses, CreateAdvisoryNeedErrors, ThrowOnError> => (options.client ?? client).post<CreateAdvisoryNeedResponses, CreateAdvisoryNeedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-needs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new advisory need task
 */
export const createAdvisoryNeedTask = <ThrowOnError extends boolean = false>(options: Options<CreateAdvisoryNeedTaskData, ThrowOnError>): RequestResult<CreateAdvisoryNeedTaskResponses, CreateAdvisoryNeedTaskErrors, ThrowOnError> => (options.client ?? client).post<CreateAdvisoryNeedTaskResponses, CreateAdvisoryNeedTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-need-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves package version
 */
export const retrieveVersion = <ThrowOnError extends boolean = false>(options?: Options<RetrieveVersionData, ThrowOnError>): RequestResult<RetrieveVersionResponses, RetrieveVersionErrors, ThrowOnError> => (options?.client ?? client).get<RetrieveVersionResponses, RetrieveVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/utility/version',
    ...options
});

/**
 * Retrieves authentication details for the logged in user
 */
export const getUserDetails = <ThrowOnError extends boolean = false>(options?: Options<GetUserDetailsData, ThrowOnError>): RequestResult<GetUserDetailsResponses, GetUserDetailsErrors, ThrowOnError> => (options?.client ?? client).get<GetUserDetailsResponses, GetUserDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/details',
    ...options
});

/**
 * Returns a list of top level topic structure
 */
export const getTopLevelTopics = <ThrowOnError extends boolean = false>(options?: Options<GetTopLevelTopicsData, ThrowOnError>): RequestResult<GetTopLevelTopicsResponses, GetTopLevelTopicsErrors, ThrowOnError> => (options?.client ?? client).get<GetTopLevelTopicsResponses, GetTopLevelTopicsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/top-level',
    ...options
});

/**
 * Find topics where talking point is linked
 */
export const getReferenceTreeForTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<GetReferenceTreeForTalkingPointData, ThrowOnError>): RequestResult<GetReferenceTreeForTalkingPointResponses, GetReferenceTreeForTalkingPointErrors, ThrowOnError> => (options.client ?? client).get<GetReferenceTreeForTalkingPointResponses, GetReferenceTreeForTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/topics/reference-tree-for-talking-point/{talking-point-id}',
    ...options
});

/**
 * Returns the surplus settings of the client
 */
export const getSurplusEntries = <ThrowOnError extends boolean = false>(options: Options<GetSurplusEntriesData, ThrowOnError>): RequestResult<GetSurplusEntriesResponses, GetSurplusEntriesErrors, ThrowOnError> => (options.client ?? client).get<GetSurplusEntriesResponses, GetSurplusEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/surplus-settings',
    ...options
});

/**
 * Returns a partner list matching the given criteria
 */
export const searchPartnersByTerm = <ThrowOnError extends boolean = false>(options: Options<SearchPartnersByTermData, ThrowOnError>): RequestResult<SearchPartnersByTermResponses, SearchPartnersByTermErrors, ThrowOnError> => (options.client ?? client).get<SearchPartnersByTermResponses, SearchPartnersByTermErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/partner-search/term',
    ...options
});

export const getAllNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetAllNotificationsData, ThrowOnError>): RequestResult<GetAllNotificationsResponses, GetAllNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<GetAllNotificationsResponses, GetAllNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications',
    ...options
});

export const getNotifications = <ThrowOnError extends boolean = false>(options: Options<GetNotificationsData, ThrowOnError>): RequestResult<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError> => (options.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications/{clientId}',
    ...options
});

export const getInternalAssetsSettings = <ThrowOnError extends boolean = false>(options: Options<GetInternalAssetsSettingsData, ThrowOnError>): RequestResult<GetInternalAssetsSettingsResponses, GetInternalAssetsSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetInternalAssetsSettingsResponses, GetInternalAssetsSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/internal-assets',
    ...options
});

/**
 * Returns sae client simulation settings
 */
export const getGeneralSettings = <ThrowOnError extends boolean = false>(options: Options<GetGeneralSettingsData, ThrowOnError>): RequestResult<GetGeneralSettingsResponses, GetGeneralSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetGeneralSettingsResponses, GetGeneralSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/general',
    ...options
});

export const getExternalAssetsSettings = <ThrowOnError extends boolean = false>(options: Options<GetExternalAssetsSettingsData, ThrowOnError>): RequestResult<GetExternalAssetsSettingsResponses, GetExternalAssetsSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetExternalAssetsSettingsResponses, GetExternalAssetsSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/external-assets',
    ...options
});

export const getCashFlowSettings = <ThrowOnError extends boolean = false>(options: Options<GetCashFlowSettingsData, ThrowOnError>): RequestResult<GetCashFlowSettingsResponses, GetCashFlowSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetCashFlowSettingsResponses, GetCashFlowSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/cash-flow',
    ...options
});

export const getCashEventSettings = <ThrowOnError extends boolean = false>(options: Options<GetCashEventSettingsData, ThrowOnError>): RequestResult<GetCashEventSettingsResponses, GetCashEventSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetCashEventSettingsResponses, GetCashEventSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/monte-carlo-simulation-settings/cash-event',
    ...options
});

/**
 * Returns all life events of clients created by the logged in user
 */
export const getLifeEvents = <ThrowOnError extends boolean = false>(options?: Options<GetLifeEventsData, ThrowOnError>): RequestResult<GetLifeEventsResponses, GetLifeEventsErrors, ThrowOnError> => (options?.client ?? client).get<GetLifeEventsResponses, GetLifeEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/life-events/for-user',
    ...options
});

/**
 * Returns all life events of a client owned by the logged in user
 */
export const getLifeEventsForClient = <ThrowOnError extends boolean = false>(options: Options<GetLifeEventsForClientData, ThrowOnError>): RequestResult<GetLifeEventsForClientResponses, GetLifeEventsForClientErrors, ThrowOnError> => (options.client ?? client).get<GetLifeEventsForClientResponses, GetLifeEventsForClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/life-events/for-client/{clientId}',
    ...options
});

/**
 * Returns relationships and nodes for the family tree
 */
export const getFamilyTree = <ThrowOnError extends boolean = false>(options: Options<GetFamilyTreeData, ThrowOnError>): RequestResult<GetFamilyTreeResponses, GetFamilyTreeErrors, ThrowOnError> => (options.client ?? client).get<GetFamilyTreeResponses, GetFamilyTreeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/family-tree/{partnerUuid}',
    ...options
});

/**
 * Update position of family tree node
 */
export const updateNodePosition = <ThrowOnError extends boolean = false>(options: Options<UpdateNodePositionData, ThrowOnError>): RequestResult<UpdateNodePositionResponses, UpdateNodePositionErrors, ThrowOnError> => (options.client ?? client).put<UpdateNodePositionResponses, UpdateNodePositionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/family-tree/{mainPartnerUuid}/node/{nodeUuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update visibility of family tree node
 */
export const updateNodeVisibility = <ThrowOnError extends boolean = false>(options: Options<UpdateNodeVisibilityData, ThrowOnError>): RequestResult<UpdateNodeVisibilityResponses, UpdateNodeVisibilityErrors, ThrowOnError> => (options.client ?? client).put<UpdateNodeVisibilityResponses, UpdateNodeVisibilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/family-tree/{mainPartnerUuid}/node/{nodeUuid}/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete all positions of the family tree for a partner
 */
export const deleteAllNodePositions = <ThrowOnError extends boolean = false>(options: Options<DeleteAllNodePositionsData, ThrowOnError>): RequestResult<DeleteAllNodePositionsResponses, DeleteAllNodePositionsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAllNodePositionsResponses, DeleteAllNodePositionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/family-tree/{mainPartnerUuid}',
    ...options
});

/**
 * Returns a list of all events (maturities, advisory need tasks, life events)
 */
export const getEvents = <ThrowOnError extends boolean = false>(options: Options<GetEventsData, ThrowOnError>): RequestResult<GetEventsResponses, GetEventsErrors, ThrowOnError> => (options.client ?? client).get<GetEventsResponses, GetEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/event/client/{clientId}',
    ...options
});

/**
 * Returns a list of all available domiciles
 */
export const getAllDomiciles = <ThrowOnError extends boolean = false>(options?: Options<GetAllDomicilesData, ThrowOnError>): RequestResult<GetAllDomicilesResponses, GetAllDomicilesErrors, ThrowOnError> => (options?.client ?? client).get<GetAllDomicilesResponses, GetAllDomicilesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/domiciles',
    ...options
});

/**
 * Returns a list of enabled domiciles
 */
export const getEnabledDomiciles = <ThrowOnError extends boolean = false>(options?: Options<GetEnabledDomicilesData, ThrowOnError>): RequestResult<GetEnabledDomicilesResponses, GetEnabledDomicilesErrors, ThrowOnError> => (options?.client ?? client).get<GetEnabledDomicilesResponses, GetEnabledDomicilesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/domiciles/enabled',
    ...options
});

/**
 * Returns all documents loaded into the system.
 */
export const getDocuments = <ThrowOnError extends boolean = false>(options?: Options<GetDocumentsData, ThrowOnError>): RequestResult<GetDocumentsResponses, GetDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<GetDocumentsResponses, GetDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents',
    ...options
});

/**
 * Downloads a document content for the provided document id and language
 */
export const downloadDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadDocumentData, ThrowOnError>): RequestResult<DownloadDocumentResponses, DownloadDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadDocumentResponses, DownloadDocumentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/{id}/{docLanguage}',
    ...options
});

/**
 * Returns false if the document is being used in client packages.
 */
export const checkClientPackageDocuments = <ThrowOnError extends boolean = false>(options: Options<CheckClientPackageDocumentsData, ThrowOnError>): RequestResult<CheckClientPackageDocumentsResponses, CheckClientPackageDocumentsErrors, ThrowOnError> => (options.client ?? client).get<CheckClientPackageDocumentsResponses, CheckClientPackageDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/{documentId}/client-package',
    ...options
});

/**
 * Returns all documents for a talking point
 */
export const getDocumentsForTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<GetDocumentsForTalkingPointData, ThrowOnError>): RequestResult<GetDocumentsForTalkingPointResponses, GetDocumentsForTalkingPointErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentsForTalkingPointResponses, GetDocumentsForTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/for-talking-point/{talkingPointId}',
    ...options
});

/**
 * Returns talking points for a specific client domicile and topic
 */
export const getTalkingPointsForDomicileByTopicId = <ThrowOnError extends boolean = false>(options: Options<GetTalkingPointsForDomicileByTopicIdData, ThrowOnError>): RequestResult<GetTalkingPointsForDomicileByTopicIdResponses, GetTalkingPointsForDomicileByTopicIdErrors, ThrowOnError> => (options.client ?? client).get<GetTalkingPointsForDomicileByTopicIdResponses, GetTalkingPointsForDomicileByTopicIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/content/talking-points-for-topic/{topicId}',
    ...options
});

/**
 * Returns all advisory needs for a given talking point and domicile. If no domicile is provided, all advisory needs for the given talking points are returned.
 */
export const getAdvisoryNeedsContentForTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<GetAdvisoryNeedsContentForTalkingPointData, ThrowOnError>): RequestResult<GetAdvisoryNeedsContentForTalkingPointResponses, GetAdvisoryNeedsContentForTalkingPointErrors, ThrowOnError> => (options.client ?? client).get<GetAdvisoryNeedsContentForTalkingPointResponses, GetAdvisoryNeedsContentForTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/content/advisory-needs-for-talking-point/{talkingPointId}',
    ...options
});

export const getFrontendConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetFrontendConfigurationData, ThrowOnError>): RequestResult<GetFrontendConfigurationResponses, GetFrontendConfigurationErrors, ThrowOnError> => (options?.client ?? client).get<GetFrontendConfigurationResponses, GetFrontendConfigurationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/configuration/frontend',
    ...options
});

/**
 * Returns a client details for the given clientId
 */
export const getClientDetails = <ThrowOnError extends boolean = false>(options: Options<GetClientDetailsData, ThrowOnError>): RequestResult<GetClientDetailsResponses, GetClientDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetClientDetailsResponses, GetClientDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/{clientId}/details',
    ...options
});

/**
 * Returns a client details for the given partner UUID
 */
export const getClientDetailsByPartnerUuid = <ThrowOnError extends boolean = false>(options: Options<GetClientDetailsByPartnerUuidData, ThrowOnError>): RequestResult<GetClientDetailsByPartnerUuidResponses, GetClientDetailsByPartnerUuidErrors, ThrowOnError> => (options.client ?? client).get<GetClientDetailsByPartnerUuidResponses, GetClientDetailsByPartnerUuidErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/uuid/{partnerUuid}/details',
    ...options
});

/**
 * Returns all partners connected to the given business relationship UUID
 */
export const getPartnersByBusinessRelationshipUuid = <ThrowOnError extends boolean = false>(options: Options<GetPartnersByBusinessRelationshipUuidData, ThrowOnError>): RequestResult<GetPartnersByBusinessRelationshipUuidResponses, GetPartnersByBusinessRelationshipUuidErrors, ThrowOnError> => (options.client ?? client).get<GetPartnersByBusinessRelationshipUuidResponses, GetPartnersByBusinessRelationshipUuidErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/partners/{businessRelationshipUuid}/business-relationship',
    ...options
});

/**
 * Returns the Business Relationship uuid with the most assets under management, using only the partnerUuid
 */
export const getBusinessRelationshipWithMostAssetsUnderManagement = <ThrowOnError extends boolean = false>(options: Options<GetBusinessRelationshipWithMostAssetsUnderManagementData, ThrowOnError>): RequestResult<GetBusinessRelationshipWithMostAssetsUnderManagementResponses, GetBusinessRelationshipWithMostAssetsUnderManagementErrors, ThrowOnError> => (options.client ?? client).get<GetBusinessRelationshipWithMostAssetsUnderManagementResponses, GetBusinessRelationshipWithMostAssetsUnderManagementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/business-relationship/{partnerUuid}/assets-under-management',
    ...options
});

/**
 * Returns the Business Relationship uuid with the most assets under management, using both the partnerUuid and the brUuids
 */
export const getBusinessRelationshipWithMostAssetsUnderManagementByRequest = <ThrowOnError extends boolean = false>(options: Options<GetBusinessRelationshipWithMostAssetsUnderManagementByRequestData, ThrowOnError>): RequestResult<GetBusinessRelationshipWithMostAssetsUnderManagementByRequestResponses, GetBusinessRelationshipWithMostAssetsUnderManagementByRequestErrors, ThrowOnError> => (options.client ?? client).get<GetBusinessRelationshipWithMostAssetsUnderManagementByRequestResponses, GetBusinessRelationshipWithMostAssetsUnderManagementByRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/business-relationship/assets-under-management',
    ...options
});

/**
 * Download all documents associated to a finalized client package in a zip archive
 */
export const getFinalizedClientPackageDocumentsZipArchive = <ThrowOnError extends boolean = false>(options: Options<GetFinalizedClientPackageDocumentsZipArchiveData, ThrowOnError>): RequestResult<GetFinalizedClientPackageDocumentsZipArchiveResponses, GetFinalizedClientPackageDocumentsZipArchiveErrors, ThrowOnError> => (options.client ?? client).get<GetFinalizedClientPackageDocumentsZipArchiveResponses, GetFinalizedClientPackageDocumentsZipArchiveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-packages/{id}/download',
    ...options
});

/**
 * Returns urls for the tax calculators
 */
export const getCalculatorUrls = <ThrowOnError extends boolean = false>(options?: Options<GetCalculatorUrlsData, ThrowOnError>): RequestResult<GetCalculatorUrlsResponses, GetCalculatorUrlsErrors, ThrowOnError> => (options?.client ?? client).get<GetCalculatorUrlsResponses, GetCalculatorUrlsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/calculators/urls',
    ...options
});

/**
 * Returns whether the liquidity overview feature is enabled
 *
 * Temporary rollout flag only. Remove this operation after Liquidity planner is approved for general availability (together with `liquidity.activated` / Octopus `YWU.backend.liquidity.activated`, the generated client call, React query key, and the navigation gate on the frontend). See family-tree feature-flag removal commit 2df0e0707 for a comparable cleanup.
 *
 */
export const getLiquidityOverviewActivated = <ThrowOnError extends boolean = false>(options?: Options<GetLiquidityOverviewActivatedData, ThrowOnError>): RequestResult<GetLiquidityOverviewActivatedResponses, GetLiquidityOverviewActivatedErrors, ThrowOnError> => (options?.client ?? client).get<GetLiquidityOverviewActivatedResponses, GetLiquidityOverviewActivatedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-overview/activated',
    ...options
});

/**
 * Returns the liquidity overview for a partner
 */
export const getLiquidityOverview = <ThrowOnError extends boolean = false>(options: Options<GetLiquidityOverviewData, ThrowOnError>): RequestResult<GetLiquidityOverviewResponses, GetLiquidityOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetLiquidityOverviewResponses, GetLiquidityOverviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-overview/{partnerUuid}',
    ...options
});

/**
 * Returns liquidity calculator calculation (metrics and preferences used; metrics match overview calculator shape)
 */
export const getLiquidityCalculatorCalculation = <ThrowOnError extends boolean = false>(options: Options<GetLiquidityCalculatorCalculationData, ThrowOnError>): RequestResult<GetLiquidityCalculatorCalculationResponses, GetLiquidityCalculatorCalculationErrors, ThrowOnError> => (options.client ?? client).get<GetLiquidityCalculatorCalculationResponses, GetLiquidityCalculatorCalculationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/calculation',
    ...options
});

/**
 * Updates liquidity calculator preferences and returns the full calculation
 */
export const updateLiquidityCalculatorCalculation = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityCalculatorCalculationData, ThrowOnError>): RequestResult<UpdateLiquidityCalculatorCalculationResponses, UpdateLiquidityCalculatorCalculationErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityCalculatorCalculationResponses, UpdateLiquidityCalculatorCalculationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/calculation/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns recurring cashflow panel settings for liquidity calculator
 */
export const getLiquidityRecurringCashflowSettings = <ThrowOnError extends boolean = false>(options: Options<GetLiquidityRecurringCashflowSettingsData, ThrowOnError>): RequestResult<GetLiquidityRecurringCashflowSettingsResponses, GetLiquidityRecurringCashflowSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetLiquidityRecurringCashflowSettingsResponses, GetLiquidityRecurringCashflowSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/recurring-cashflows',
    ...options
});

/**
 * Updates recurring cashflow panel settings for liquidity calculator
 */
export const updateLiquidityRecurringCashflowPanelSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityRecurringCashflowPanelSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityRecurringCashflowPanelSettingsResponses, UpdateLiquidityRecurringCashflowPanelSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityRecurringCashflowPanelSettingsResponses, UpdateLiquidityRecurringCashflowPanelSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/recurring-cashflows/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a recurring cashflow item setting for liquidity calculator
 */
export const updateLiquidityRecurringCashflowItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityRecurringCashflowItemSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityRecurringCashflowItemSettingsResponses, UpdateLiquidityRecurringCashflowItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityRecurringCashflowItemSettingsResponses, UpdateLiquidityRecurringCashflowItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/recurring-cashflows/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Selects or deselects all recurring cashflow items for liquidity calculator
 *
 * Bulk-updates the enabled state of every recurring cashflow item of the client. When `selected` is true all items are selected (items that are enforce-disabled stay off); when false all items are deselected. Returns the updated panel settings.
 */
export const selectAllLiquidityRecurringCashflowItems = <ThrowOnError extends boolean = false>(options: Options<SelectAllLiquidityRecurringCashflowItemsData, ThrowOnError>): RequestResult<SelectAllLiquidityRecurringCashflowItemsResponses, SelectAllLiquidityRecurringCashflowItemsErrors, ThrowOnError> => (options.client ?? client).put<SelectAllLiquidityRecurringCashflowItemsResponses, SelectAllLiquidityRecurringCashflowItemsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/recurring-cashflows/select-all',
    ...options
});

/**
 * Returns one-off cashflow panel settings for liquidity calculator
 */
export const getLiquidityOneOffCashflowSettings = <ThrowOnError extends boolean = false>(options: Options<GetLiquidityOneOffCashflowSettingsData, ThrowOnError>): RequestResult<GetLiquidityOneOffCashflowSettingsResponses, GetLiquidityOneOffCashflowSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetLiquidityOneOffCashflowSettingsResponses, GetLiquidityOneOffCashflowSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/one-off-cashflows',
    ...options
});

/**
 * Updates one-off cashflow panel settings for liquidity calculator
 */
export const updateLiquidityOneOffCashflowPanelSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityOneOffCashflowPanelSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityOneOffCashflowPanelSettingsResponses, UpdateLiquidityOneOffCashflowPanelSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityOneOffCashflowPanelSettingsResponses, UpdateLiquidityOneOffCashflowPanelSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/one-off-cashflows/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a one-off cashflow item setting for liquidity calculator
 */
export const updateLiquidityOneOffCashflowItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityOneOffCashflowItemSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityOneOffCashflowItemSettingsResponses, UpdateLiquidityOneOffCashflowItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityOneOffCashflowItemSettingsResponses, UpdateLiquidityOneOffCashflowItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/one-off-cashflows/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Selects or deselects all one-off cashflow items for liquidity calculator
 *
 * Bulk-updates the enabled state of every one-off cashflow item of the client. When `selected` is true all items are selected (items that are enforce-disabled stay off); when false all items are deselected. Returns the updated panel settings.
 */
export const selectAllLiquidityOneOffCashflowItems = <ThrowOnError extends boolean = false>(options: Options<SelectAllLiquidityOneOffCashflowItemsData, ThrowOnError>): RequestResult<SelectAllLiquidityOneOffCashflowItemsResponses, SelectAllLiquidityOneOffCashflowItemsErrors, ThrowOnError> => (options.client ?? client).put<SelectAllLiquidityOneOffCashflowItemsResponses, SelectAllLiquidityOneOffCashflowItemsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/one-off-cashflows/select-all',
    ...options
});

/**
 * Returns cash-with-JB panel settings for the liquidity calculator (cash selection only)
 */
export const getLiquidityCashWithJbSettings = <ThrowOnError extends boolean = false>(options: Options<GetLiquidityCashWithJbSettingsData, ThrowOnError>): RequestResult<GetLiquidityCashWithJbSettingsResponses, GetLiquidityCashWithJbSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetLiquidityCashWithJbSettingsResponses, GetLiquidityCashWithJbSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/cash-with-jb',
    ...options
});

/**
 * Updates cash-with-JB panel settings for the liquidity calculator
 */
export const updateLiquidityCashWithJbPanelSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityCashWithJbPanelSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityCashWithJbPanelSettingsResponses, UpdateLiquidityCashWithJbPanelSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityCashWithJbPanelSettingsResponses, UpdateLiquidityCashWithJbPanelSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/cash-with-jb/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a cash-with-JB item setting for the liquidity calculator
 */
export const updateLiquidityCashWithJbItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityCashWithJbItemSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityCashWithJbItemSettingsResponses, UpdateLiquidityCashWithJbItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityCashWithJbItemSettingsResponses, UpdateLiquidityCashWithJbItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/cash-with-jb/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns cash-with-other-banks panel settings for the liquidity calculator (cash selection only)
 */
export const getLiquidityCashWithOtherBanksSettings = <ThrowOnError extends boolean = false>(options: Options<GetLiquidityCashWithOtherBanksSettingsData, ThrowOnError>): RequestResult<GetLiquidityCashWithOtherBanksSettingsResponses, GetLiquidityCashWithOtherBanksSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetLiquidityCashWithOtherBanksSettingsResponses, GetLiquidityCashWithOtherBanksSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/cash-with-other-banks',
    ...options
});

/**
 * Updates cash-with-other-banks panel settings for the liquidity calculator
 */
export const updateLiquidityCashWithOtherBanksPanelSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityCashWithOtherBanksPanelSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityCashWithOtherBanksPanelSettingsResponses, UpdateLiquidityCashWithOtherBanksPanelSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityCashWithOtherBanksPanelSettingsResponses, UpdateLiquidityCashWithOtherBanksPanelSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/cash-with-other-banks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates a cash-with-other-banks item setting for the liquidity calculator
 */
export const updateLiquidityCashWithOtherBanksItemSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateLiquidityCashWithOtherBanksItemSettingsData, ThrowOnError>): RequestResult<UpdateLiquidityCashWithOtherBanksItemSettingsResponses, UpdateLiquidityCashWithOtherBanksItemSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateLiquidityCashWithOtherBanksItemSettingsResponses, UpdateLiquidityCashWithOtherBanksItemSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/liquidity-calculator/cash-with-other-banks/item/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves the complete balance sheet with all balance entries for the given partner
 */
export const getBalanceSheet = <ThrowOnError extends boolean = false>(options: Options<GetBalanceSheetData, ThrowOnError>): RequestResult<GetBalanceSheetResponses, GetBalanceSheetErrors, ThrowOnError> => (options.client ?? client).get<GetBalanceSheetResponses, GetBalanceSheetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/balance-sheet/{partnerUuid}',
    ...options
});

/**
 * Returns all advisory needs for a given talking point and domicile. If no domicile is provided, all advisory needs for the given talking points are returned.
 */
export const getAdvisoryNeedsForTalkingPoint = <ThrowOnError extends boolean = false>(options: Options<GetAdvisoryNeedsForTalkingPointData, ThrowOnError>): RequestResult<GetAdvisoryNeedsForTalkingPointResponses, GetAdvisoryNeedsForTalkingPointErrors, ThrowOnError> => (options.client ?? client).get<GetAdvisoryNeedsForTalkingPointResponses, GetAdvisoryNeedsForTalkingPointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-needs/for-talking-point/{talkingPointId}',
    ...options
});

/**
 * Returns all advisory need tasks for all clients created by currently logged in user
 */
export const getAdvisoryNeedTasksForLoggedInUser = <ThrowOnError extends boolean = false>(options?: Options<GetAdvisoryNeedTasksForLoggedInUserData, ThrowOnError>): RequestResult<GetAdvisoryNeedTasksForLoggedInUserResponses, GetAdvisoryNeedTasksForLoggedInUserErrors, ThrowOnError> => (options?.client ?? client).get<GetAdvisoryNeedTasksForLoggedInUserResponses, GetAdvisoryNeedTasksForLoggedInUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-need-tasks/for-user',
    ...options
});

/**
 * Returns all advisory need tasks for a clients created by currently logged in user
 */
export const getAdvisoryNeedTasksForClient = <ThrowOnError extends boolean = false>(options: Options<GetAdvisoryNeedTasksForClientData, ThrowOnError>): RequestResult<GetAdvisoryNeedTasksForClientResponses, GetAdvisoryNeedTasksForClientErrors, ThrowOnError> => (options.client ?? client).get<GetAdvisoryNeedTasksForClientResponses, GetAdvisoryNeedTasksForClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/advisory-need-tasks/for-client/{clientId}',
    ...options
});

/**
 * Download PROD DB export as Excel
 */
export const getDbExport = <ThrowOnError extends boolean = false>(options?: Options<GetDbExportData, ThrowOnError>): RequestResult<GetDbExportResponses, GetDbExportErrors, ThrowOnError> => (options?.client ?? client).get<GetDbExportResponses, GetDbExportErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/content-admin/db-export',
    ...options
});

/**
 * Clear expired OBO tokens from the cache
 */
export const clearExpiredTokens = <ThrowOnError extends boolean = false>(options?: Options<ClearExpiredTokensData, ThrowOnError>): RequestResult<ClearExpiredTokensResponses, ClearExpiredTokensErrors, ThrowOnError> => (options?.client ?? client).delete<ClearExpiredTokensResponses, ClearExpiredTokensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/system/integration/token-cache/clear-expired',
    ...options
});

/**
 * Clear all OBO tokens in cache
 */
export const clearAllTokens = <ThrowOnError extends boolean = false>(options?: Options<ClearAllTokensData, ThrowOnError>): RequestResult<ClearAllTokensResponses, ClearAllTokensErrors, ThrowOnError> => (options?.client ?? client).delete<ClearAllTokensResponses, ClearAllTokensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/system/integration/token-cache/clear-all',
    ...options
});

/**
 * Deletes a document into the system.
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentData, ThrowOnError>): RequestResult<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/{id}',
    ...options
});

/**
 * Deletes a client - talking point relation
 */
export const deleteClientTalkingPointRelation = <ThrowOnError extends boolean = false>(options: Options<DeleteClientTalkingPointRelationData, ThrowOnError>): RequestResult<DeleteClientTalkingPointRelationResponses, DeleteClientTalkingPointRelationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClientTalkingPointRelationResponses, DeleteClientTalkingPointRelationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client-talking-points/{relationId}',
    ...options
});
